<template>
  <div class="app-container">
    <header>
      <div class="header-content">
        <div class="logo-section">
          <img v-if="theme" src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载" @click="gohome">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png" alt="待加载" @click="gohome">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="header-spacer"></div>
        <div class="header-actions">
          <!-- 返回主页按钮 -->
          <div class="home-btn" @click="gohome">
            <span class="iconfont">&#xe632;</span>
            <span>返回主页</span>
          </div>
          <!-- 生图记录按钮 -->
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe605;</span>
            <span>生图记录</span>
          </div>
          <!--支持与反馈按钮 -->
          <div class="header-btn" @click="handleOpenFeedback">
            <span class="iconfont">&#xe67c;</span>
            <span>支持与反馈</span>
          </div>
          <!-- 用户头像 -->
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>
    <div class="body">
      <div class="content-wrapper">
        <!-- 左侧:上传视频 -->
        <div class="upload-section">
          <div class="upload-card">
            <div class="section-title">上传视频</div>
            <div class="upload-area" @click="handleVideoUploadClick" @dragover.prevent @drop="handleVideoDrop"
              v-loading="loading">
              <div v-if="videoPath" class="close-btn" @click.stop="deleteVideo">×</div>
              <div v-if="!videoPath" class="upload-placeholder">
                <div class="upload-icon">🎬</div>
                <div class="upload-text">拖拽视频或点击上传</div>
                <div class="upload-button">上传</div>
              </div>
              <video v-if="videoPath" :src="videoPath" class="uploaded-video" controls></video>
            </div>
            <div class="upload-tips">
              <div class="tip-item">
                <span class="tip-label">文件大小:</span>
                <span class="tip-value">100MB及以下</span>
              </div>
              <div class="tip-item">
                <span class="tip-label">文件格式:</span>
                <span class="tip-value">MP4、MOV、AVI</span>
              </div>
              <div class="tip-desc">建议上传分辨率较低的视频以获得更明显的放大效果，时长30秒以内为佳。</div>
            </div>
          </div>
        </div>

        <!-- 右侧:输出视频 -->
        <div class="output-section">
          <div class="output-card">
            <div class="section-title">输出视频</div>
            <div class="output-area">
              <div v-if="processedVideo || originalVideo" class="close-btn" @click.stop="clearOutput">×</div>
              <div v-if="!processedVideo && !originalVideo && !tips" class="output-placeholder">
                <div class="output-icon">🎥</div>
                <div class="output-text">在线生成</div>
              </div>
              <video v-if="processedVideo" :src="processedVideo" class="output-video" controls></video>
              <div v-if="!processedVideo && originalVideo && !tips" class="output-placeholder">
                <div class="output-icon">📹</div>
                <div class="output-text">视频已生成</div>
                <div class="output-hint">点击下方按钮下载查看</div>
              </div>
              <div v-if="tips" class="processing-mask">
                <div class="processing-text">{{ tips }}</div>
              </div>
            </div>
            <div class="output-tips">
              <div class="tip-item">
                <div class="action-btn" @click="handleDownload">下载视频</div>
                <div class="action-btn" @click="handleCopyPath">复制链接</div>
              </div>
              <div class="tip-desc">输出视频为放大后的高分辨率MP4格式。</div>
              <div class="tip-desc">如需进一步编辑，请下载后使用专业视频编辑软件处理。</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-actions">
        <div class="help-btn" @mouseenter="showHelpTip = true" @mouseleave="showHelpTip = false">
          使用说明
          <div v-if="showHelpTip" class="help-tooltip">
            <div class="tooltip-title">视频放大使用说明</div>
            <div class="tooltip-content">
              <div class="tip-section">
                <p>为了获得更好的视频放大效果,请注意以下要点:</p>
                <div class="section-title">通用提醒:</div>
                <p>建议上传分辨率在1080P以内、时长30秒以内的视频,以确保最佳处理效果。</p>
              </div>
              <div class="tip-section">
                <div class="section-title">关于分辨率选择:</div>
                <p>1. 720p: 适合快速预览放大效果。</p>
                <p>2. 1080p: 标准高清分辨率。</p>
                <p>3. 1.5K: 中等高清分辨率,效果良好。</p>
                <p>4. 2K: 高清分辨率,效果优秀。</p>
              </div>
              <div class="tip-section">
                <div class="section-title">处理时间:</div>
                <p>预计等待时间根据视频时长和目标分辨率而定,分辨率越高处理时间越长,请耐心等待。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="generate-btn" @click="start_process">视频放大</div>
        <div class="save-btn" @click="handleSave">保存视频</div>
      </div>
    </div>
    <ImageModal class="modal" :visible="isModalVisible" :img_url="imageUrl" @update:visible="isModalVisible = $event"
      :img_show="false" :video_show="true" :video_src="video_src"></ImageModal>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
import { Message } from 'element-ui'
import videoRequest, { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiVideoRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { VIDEO_UPSCALE } from '@/enums/common/modules'
import theme from '@/utils/theme'
import { mapGetters } from 'vuex'
import videoUpscaleWorkflow from '@/api/json_api/视频超分放大.json'
export default {
  name: 'VideoUpscale',
  computed: {
    ...mapGetters(['avatar'])
  },
  data() {
    return {
      taskLogId: '',
      value: false,
      videoPath: '',
      processedVideo: '',
      originalVideo: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',
      loading: false,
      day: theme.day,
      night: theme.night,
      theme: true,
      // 防呆设计
      isModalVisible: false,
      imageUrl: '',
      img_show: false,
      video_src: '',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null,
      // 新增字段
      showHelpTip: false // 控制帮助气泡显示
    }
  },
  created() {
    this.videoPath = localStorageUtils.getItem('video_upscale')
    this.processedVideo = localStorageUtils.getItem('video_upscale_showvideo')
    this.originalVideo = localStorageUtils.getItem('video_upscale_original')
    // 将ID值赋给讨论区类型
    this.disscussType = VIDEO_UPSCALE
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
  },
  mounted() {
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
    this.$nextTick(() => {
      this.source_html()
    })
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 返回主页
    gohome() {
      this.$router.push({ path: '/' })
    },
    // 跳转到生图记录页面
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 打开支持与反馈(讨论区)
    handleOpenFeedback() {
      this.boardvisible = true
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 防呆设计
    show_video(event) {
      event.preventDefault()
      event.stopPropagation()
      this.isModalVisible = true
      this.video_src = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/wan_move_show_video/wan_move.mp4'
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + Enter
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault()
        this.start_process()
      }
    },
    // 上传视频到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/video_upscale/'
      const fileName = `${Date.now()}_${file.name}`
      console.log('上传到OSS:', tmp + fileName)
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    // 点击上传按钮
    handleVideoUploadClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'video/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processVideo(file)
        }
      }
      input.click()
    },
    // 拖拽上传事件
    handleVideoDrop(event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file && file.type.startsWith('video/')) {
        this.processVideo(file)
      } else {
        Message.error('请上传有效的视频文件')
      }
    },
    // 视频处理函数
    async processVideo(file) {
      this.loading = true
      // 检查文件大小 (100MB限制)
      const maxSize = 100 * 1024 * 1024
      if (file.size > maxSize) {
        Message.error('视频文件过大,请上传100MB以内的视频!')
        this.loading = false
        return
      }
      const ossClient = await getOssClient()
      // 上传视频到OSS
      const videoUrl = await this.uploadToOSS(file, ossClient)
      if (videoUrl) {
        this.videoPath = videoUrl
        localStorageUtils.setItem('video_upscale', videoUrl)
        Message.success('视频加载成功,可以准备开始任务!')
      } else {
        Message.error('视频上传失败,请检查网络配置!')
      }
      this.loading = false
    },
    deleteVideo() {
      this.videoPath = ''
      this.processing = false
      this.tips = false
      this.originalVideo = ''
      this.processedVideo = ''
      localStorage.removeItem('video_upscale')
      localStorage.removeItem('video_upscale_showvideo')
      localStorage.removeItem('video_upscale_original')
    },
    // 清空输出视频
    clearOutput() {
      this.processedVideo = ''
      this.originalVideo = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('video_upscale_showvideo')
      localStorage.removeItem('video_upscale_original')
    },
    // 下载视频功能
    async handleDownload() {
      if (!this.originalVideo) {
        Message.warning('请先生成视频,然后再进行下载!')
        return
      }
      try {
        Message.info('正在下载视频...')
        const response = await fetch(this.originalVideo)
        const blob = await response.blob()
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        const timestamp = new Date().getTime()
        link.download = `video_upscale_${timestamp}.mp4`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        Message.success('视频下载成功!')
      } catch (error) {
        console.error('下载视频失败:', error)
        Message.error('下载视频失败,请稍后再试!')
      }
    },
    // 复制链接功能
    async handleCopyPath() {
      if (!this.originalVideo) {
        Message.warning('请先生成视频,然后再复制链接!')
        return
      }
      try {
        const textarea = document.createElement('textarea')
        textarea.value = this.originalVideo
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('视频链接复制成功!')
      } catch {
        Message.error('复制链接失败,请稍后再试!')
      }
    },
    // 保存功能(下载视频)
    async handleSave() {
      await this.handleDownload()
    },
    // 替换工作流变量
    replaceWorkflowVariables(workflow, videoUrl, outputFilename) {
      const workflowCopy = JSON.parse(JSON.stringify(workflow))
      console.log('开始替换工作流变量...')
      console.log('参数:', { videoUrl, outputFilename })

      // 遍历所有节点替换变量
      for (const nodeId in workflowCopy) {
        const node = workflowCopy[nodeId]
        if (node.inputs) {
          for (const inputKey in node.inputs) {
            const inputValue = node.inputs[inputKey]
            if (typeof inputValue === 'string') {
              if (inputValue.includes('{{VIDEO_URL}}')) {
                node.inputs[inputKey] = videoUrl
                console.log(`节点${nodeId}.${inputKey}: {{VIDEO_URL}} -> ${videoUrl}`)
              } else if (inputValue.includes('{{OUTPUT_FILENAME}}')) {
                node.inputs[inputKey] = outputFilename
                console.log(`节点${nodeId}.${inputKey}: {{OUTPUT_FILENAME}} -> ${outputFilename}`)
              }
            }
          }
        }
      }
      return workflowCopy
    },
    // 应用函数
    async start_process() {
      this.processedVideo = ''
      if (this.videoPath === '' || this.videoPath === null) {
        Message.warning('请先选择视频文件')
        return
      }
      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      this.processing = true
      this.tips = '任务正在生成,请耐心等待.....'

      // 生成输出文件名（必须是JSON数组格式的字符串，与工作流中的格式匹配）
      const timestamp = Date.now()
      const randomNum = Math.floor(Math.random() * 99999)
      const outputFilename = `["tmp-comfyui/video_upscale/${timestamp}_${randomNum}.mp4"]`

      // 替换工作流变量
      const promptData = this.replaceWorkflowVariables(
        videoUpscaleWorkflow,
        this.videoPath,
        outputFilename
      )

      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }

      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return await videoRequest({
            url: 'prompt',
            method: 'post',
            data
          })
        } catch (error) {
          console.error('发送请求失败：', error)
          if (error.response) {
            const status = error.response.status
            if (status === 400) {
              Message.error('请求参数错误(400)，请检查输入参数是否正确')
            }
          } else if (error.request) {
            Message.error('网络连接异常，请检查网络或查看控制台')
          } else {
            Message.error('请求配置错误，请联系开发者')
          }
          this.processing = false
          this.tips = false
          return null
        }
      }

      const fetchVideoResult = async (promptId) => {
        try {
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          console.log('[VideoUpscale] history API 原始响应:', response)
          console.log('[VideoUpscale] history API response.data:', response.data)

          const promptInfo = response.data[promptId]
          console.log('[VideoUpscale] promptInfo:', promptInfo)

          if (!promptInfo) {
            console.error('[VideoUpscale] 未找到 promptInfo，promptId:', promptId)
            console.error('[VideoUpscale] response.data 的所有 keys:', Object.keys(response.data))
            Message.error('获取结果失败：未找到任务信息')
            this.processing = false
            this.tips = false
            return
          }

          console.log('[VideoUpscale] 任务状态信息:', promptInfo.status)

          if (promptInfo.status && promptInfo.status.status_str === 'success') {
            console.log('[VideoUpscale] 任务执行成功，开始解析输出节点')

            // 检查 prompt 结构
            console.log('[VideoUpscale] promptInfo.prompt:', promptInfo.prompt)
            if (!promptInfo.prompt || !promptInfo.prompt[2]) {
              console.error('[VideoUpscale] prompt 结构异常，缺少 prompt[2]')
              console.error('[VideoUpscale] promptInfo.prompt 内容:', promptInfo.prompt)
              Message.error('获取视频路径失败：工作流结构异常')
              this.processing = false
              this.tips = false
              return
            }

            // 从节点80获取输出视频（V2工作流 VideoCombineOSS 节点ID为80）
            const node80 = promptInfo.prompt[2][80]
            console.log('[VideoUpscale] 节点80原始数据:', node80)

            let videoPath = null

            // 获取视频路径
            if (node80 && node80.inputs && node80.inputs.filename) {
              console.log('[VideoUpscale] 节点80 filename 原始值:', node80.inputs.filename)
              try {
                const filenameArr = JSON.parse(node80.inputs.filename)
                console.log('[VideoUpscale] filename 解析结果:', filenameArr)
                if (filenameArr && filenameArr.length > 0) {
                  videoPath = `https://mj-comfy-ui.oss-cn-shenzhen.aliyuncs.com/${filenameArr[0]}`
                  console.log('[VideoUpscale] 最终视频路径:', videoPath)
                } else {
                  console.error('[VideoUpscale] filename 数组为空')
                }
              } catch (parseErr) {
                console.error('[VideoUpscale] filename JSON 解析失败:', parseErr)
                console.error('[VideoUpscale] filename 原始字符串:', node80.inputs.filename)
              }
            } else {
              console.error('[VideoUpscale] 节点80不存在或缺少filename字段')
              console.error('[VideoUpscale] node80 存在:', !!node80)
              if (node80) {
                console.error('[VideoUpscale] node80.inputs 存在:', !!node80.inputs)
                if (node80.inputs) {
                  console.error('[VideoUpscale] node80.inputs 所有 keys:', Object.keys(node80.inputs))
                }
              }
            }

            if (videoPath) {
              this.originalVideo = videoPath
              this.processedVideo = videoPath
              localStorageUtils.setItem('video_upscale_original', videoPath)
              localStorageUtils.setItem('video_upscale_showvideo', videoPath)
              this.getTaskEnd(videoPath, this.taskLogId)
              this.processing = false
              this.tips = false
              Message.success('视频放大生成成功!')
              return
            }
            Message.error('获取视频路径失败，请重试')
            this.processing = false
            this.tips = false
          } else {
            console.error('[VideoUpscale] 任务执行失败或状态异常')
            console.error('[VideoUpscale] 完整 promptInfo:', JSON.parse(JSON.stringify(promptInfo)))
            if (promptInfo.status) {
              console.error('[VideoUpscale] 状态详情:', promptInfo.status)
              console.error('[VideoUpscale] status_str:', promptInfo.status.status_str)
            }
            Message.error('视频放大失败，请重试')
            this.processing = false
            this.tips = false
          }
        } catch (error) {
          console.error('[VideoUpscale] 获取视频结果异常:', error)
          console.error('[VideoUpscale] 错误详情:', error.message)
          if (error.response) {
            console.error('[VideoUpscale] HTTP 状态码:', error.response.status)
            console.error('[VideoUpscale] HTTP 响应数据:', error.response.data)
          }
          Message.error('获取结果失败，请重试')
          this.processing = false
          this.tips = false
        }
      }

      const listenToProgress = (promptId) => {
        console.log('[VideoUpscale] 建立 WebSocket 连接, clientId:', this.clientId)
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          console.error('[VideoUpscale] WebSocket 连接超时(2000ms)')
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('[VideoUpscale] WebSocket 连接成功，提交服务器开始生成...')
          getTaskStart({
            type: VIDEO_UPSCALE,
            prompt: '',
            input_images: this.videoPath ? [this.videoPath] : []
          }).then(rep => {
            this.taskLogId = rep.data.task.id
            console.log('[VideoUpscale] 任务已记录, taskLogId:', this.taskLogId)
          }).catch(err => {
            console.error('[VideoUpscale] 记录任务起始失败:', err)
          })
          clearTimeout(wsTimeout)
        }

        this.ws.onerror = (error) => {
          console.error('[VideoUpscale] WebSocket 连接错误:', error)
          Message.error('WebSocket 连接异常，请检查网络或刷新页面重试')
          this.processing = false
          this.tips = false
        }

        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              console.log('[VideoUpscale] WS 收到消息:', msg)

              if (msg.type === 'executing') {
                const execData = msg.data
                console.log('[VideoUpscale] 正在执行节点:', execData.node, 'prompt_id:', execData.prompt_id)
                if (execData.node === null && execData.prompt_id === promptId) {
                  console.log('[VideoUpscale] 执行完成，准备获取结果')
                  this.ws.close()
                  await fetchVideoResult(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
              } else if (msg.type === 'execution_error') {
                console.error('[VideoUpscale] 工作流执行出错:', msg.data)
                Message.error('工作流执行出错，请查看控制台详情')
                this.ws.close()
                this.processing = false
                this.tips = false
              } else {
                console.log('[VideoUpscale] 其他类型 WS 消息, type:', msg.type)
              }
            } catch (error) {
              console.error('[VideoUpscale] WS 消息解析失败:', error)
              console.error('[VideoUpscale] 原始消息内容:', event.data)
              this.tips = false
            }
          } else {
            console.log('[VideoUpscale] WS 收到非字符串类型数据:', typeof data, data)
          }
        }

        this.ws.onclose = (event) => {
          console.log('[VideoUpscale] WebSocket 连接关闭, code:', event.code, 'reason:', event.reason)
          this.processing = false
          this.tips = false
          try {
            const index = cudaIndexNum()
            cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) {
            console.log('[VideoUpscale] 释放 CUDA 状态异常:', error)
          }
        }
      }

      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    },
    async getTaskEnd(tmp, taskLogId) {
      const info = {
        details: [{ path: tmp }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.content-wrapper')
      if (main) {
        main.style.opacity = this.theme === false ? 0.75 : 1
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

.app-container {
  width: 100vw;
  height: 100vh;
  background: #f5f7fa;
  overflow: hidden;
}

// Header样式
header {
  height: 95px;
  width: 100%;
  padding: 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid #e5e7eb;
  background: white;

  .header-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo-section {
    width: 230px;
    height: 75px;
    display: flex;
    align-items: center;
    padding: 10px;

    img {
      width: 230px;
      object-fit: cover;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .header-spacer {
    flex: 1;
  }

  .header-actions {
    display: flex;
    gap: 20px;
    align-items: center;

    .home-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: #ff8c42;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .header-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: rgba(39, 41, 46, 0.05);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      color: #333;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #f0f0f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      }
    }

    .user-avatar {
      display: flex;
      width: 50px;
      height: 50px;
      border: 2px solid #e5e7eb;
      border-radius: 50%;
      overflow: hidden;
      justify-content: center;
      align-items: center;

      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  background: #ffffff;
  padding: 40px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .content-wrapper {
    display: flex;
    gap: 50px;
    max-width: 1600px;
    margin: 0 auto;
    height: calc(100% - 140px);
  }

  // 上传区域和输出区域通用样式
  .upload-section,
  .output-section {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .section-title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }

  .upload-card,
  .output-card {
    background: white;
    border-radius: 30px;
    padding: 30px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 600px;
  }

  // 上传区域样式
  .upload-area {
    position: relative;
    flex: 1;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    overflow: hidden;
    min-height: 400px;
    height: 400px;

    &:hover {
      border-color: #ff8c42;
      background: #fff8f3;
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 0, 0, 0.8);
        transform: scale(1.1);
      }
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;

      .upload-icon {
        font-size: 60px;
      }

      .upload-text {
        font-size: 16px;
        color: #6c757d;
      }

      .upload-button {
        padding: 10px 30px;
        background: #ff8c42;
        color: white;
        border-radius: 25px;
        font-size: 16px;
        transition: all 0.3s;

        &:hover {
          background: #ff7a2e;
          transform: translateY(-2px);
        }
      }
    }

    .uploaded-video {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .upload-tips {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    color: #6c757d;

    .tip-item {
      display: flex;
      gap: 5px;
      align-items: center;

      .tip-label {
        font-weight: 600;
        color: #495057;
      }

      .tip-value {
        color: #ff8c42;
      }
    }

    .tip-desc {
      line-height: 1.6;
      color: #868e96;

      .link-text {
        color: #ff8c42;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          color: #ff7a2e;
        }
      }
    }
  }

  // 输出区域样式
  .output-area {
    position: relative;
    flex: 1;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 400px;
    height: 400px;

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 0, 0, 0.8);
        transform: scale(1.1);
      }
    }

    .output-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;

      .output-icon {
        font-size: 60px;
        opacity: 0.3;
      }

      .output-text {
        font-size: 16px;
        color: #adb5bd;
      }

      .output-hint {
        font-size: 14px;
        color: #ff8c42;
        margin-top: 10px;
      }
    }

    .output-video {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .processing-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;

      .processing-text {
        font-size: 18px;
        color: #ff8c42;
        font-weight: 600;
      }
    }
  }

  // 输出提示区域样式
  .output-tips {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    color: #6c757d;

    .tip-item {
      display: flex;
      gap: 15px;

      .action-btn {
        flex: 1;
        padding: 12px;
        background: white;
        border: 2px solid #dee2e6;
        border-radius: 10px;
        text-align: center;
        font-size: 16px;
        color: #495057;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          border-color: #ff8c42;
          color: #ff8c42;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(255, 140, 66, 0.2);
        }
      }
    }

    .tip-desc {
      line-height: 1.6;
      color: #868e96;
    }
  }

  // 底部操作栏
  .bottom-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-top: 70px;
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;

    .generate-btn {
      padding: 12px 100px;
      background: #ff8c42;
      color: white;
      border-radius: 30px;
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);

      &:hover {
        background: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(255, 140, 66, 0.6);
      }

      &:active {
        transform: translateY(0);
      }
    }

    .save-btn,
    .copy-btn {
      padding: 12px 40px;
      background: white;
      color: #ff8c42;
      border: 2px solid #ff8c42;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #ff8c42;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .help-btn {
      position: relative;
      padding: 12px 40px;
      background: white;
      color: #a5a5a5;
      border: 2px solid #c7c7c7;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #ff8c42;
        color: white;
        border: 2px solid #ff8c42;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }

      .help-tooltip {
        position: absolute;
        bottom: 70px;
        right: 0;
        width: 650px;
        max-height: 1000px;
        overflow-y: auto;
        background: white;
        border-radius: 15px;
        padding: 25px;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        animation: fadeInUp 0.3s ease;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          right: 15px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid white;
        }

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ff8c42;
          border-radius: 3px;

          &:hover {
            background: #ff7a2e;
          }
        }

        .tooltip-title {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #ff8c42;
        }

        .tooltip-content {
          font-size: 14px;
          line-height: 1.8;
          color: #555;

          .tip-section {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }

            .section-title {
              font-size: 16px;
              font-weight: 600;
              color: #ff8c42;
              margin-bottom: 10px;
            }

            p {
              margin: 8px 0;
              padding-left: 10px;
              color: #666;
            }
          }
        }
      }
    }
  }
}
</style>
